import { ArrowBack, AttachMoney } from '@mui/icons-material';
import { Box, Card, CardContent, CardHeader, Grid, IconButton, Table, TableBody, TableCell, TableRow } from '@mui/material';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import MiniStatisticsCard from 'examples/Cards/StatisticsCards/MiniStatisticsCard';
import { CustomDescrypt } from 'global/func';
import { getDataWithResponse } from 'global/getFunc';
import { postDataWithResponse } from 'global/postFunc';
import { MaterialReactTable } from 'material-react-table';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import userStore from 'store/userStore';

const RincianBelanja = () => {
    const { user, addReq } = userStore(state => ({ user: state.user, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));

    const navigate = useNavigate()
    const location = useLocation()
    const locationData = location.state
    const data = locationData.subKegiatan
    const opd = locationData.opd

    const [kegiatan, setKegiatan] = useState({})
    const [program, setProgram] = useState({})
    const [listRincian, setListRincian] = useState([])

    const [totalRincian, setTotalRincian] = useState(0)

    const getTrKegiatan = () => {
        addReq()
        getDataWithResponse(
            // `/admin-opd/get-tr-perencanaan-opd/${tahunAnggaran.ta}/${params}`,
            `/admin-opd/get-tr-perencanaan-by-id/${data.ta}-${data.kd_pd}-${data.kegiatan}`,
            decryptedUser,
            (res) => {
                setKegiatan(res)
                console.log(res);
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }
        )
    }


    const getTrProgram = () => {
        addReq()
        getDataWithResponse(
            // `/admin-opd/get-tr-perencanaan-opd/${tahunAnggaran.ta}/${params}`,
            `/admin-opd/get-tr-perencanaan-by-id/${data.ta}-${data.kd_pd}-${data.program}`,
            decryptedUser,
            (res) => {
                setProgram(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }
        )
    }

    useEffect(() => {
        getTrKegiatan()
        getTrProgram()
        console.log(locationData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const reqRincianBelanja = () => {
        addReq()
        postDataWithResponse(
            '/admin-opd/komponen-belanja',
            {
                kd_subkegiatan: data.sub_kegiatan,
                kd_pd: data.kd_pd,
                ta: data.ta
            },
            decryptedUser,
            (res) => {
                setListRincian(res)
                const sum = res.reduce((accumulator, object) => {
                    return accumulator + parseInt(object.anggaran);
                }, 0);
                setTotalRincian(sum)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    useEffect(() => {
        reqRincianBelanja()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [loading, setLoading] = useState(false)

    const columns = [
        {
            accessorKey: 'nama_komponen',
            header: 'Uraian',
            size: 500,
            Cell: ({ cell }) => (
                <Box>
                    <ArgonTypography
                        fontWeight='bold'
                        fontSize='small'
                        variant="inherit"
                        color={cell.row.original.ket === 'notequal' ? 'error' : 'inherit'}
                    >
                        {cell.row.original.status === 'kel_paket' ? '[#] ' : ''}{cell.getValue()}
                    </ArgonTypography>
                    {
                        cell.row.original.status === 'komponen' &&
                        (<ArgonTypography
                            fontSize="small"
                            variant="inherit"
                            color={cell.row.original.ket === 'notequal' ? 'error' : 'inherit'}
                        >
                            Spesifikasi : {cell.row.original.spesifikasi}
                        </ArgonTypography>)
                    }
                </Box>
            )
        },
        {
            accessorKey: 'koefisien',
            header: 'Koefisien',
            size: 20,
            Cell: ({ cell }) => (
                cell.row.original.status === 'komponen' &&
                (
                    <ArgonTypography
                        // fontWeight={(cell.row.original.status === 'Program' || cell.row.original.status === 'Kegiatan') === 'Program' && 'bold'}
                        variant="inherit"
                        fontSize="small"
                        color={cell.row.original.ket === 'notequal' ? 'error' : 'inherit'}
                    >
                        {cell.getValue() + ' ' + cell.row.original.satuan}
                    </ArgonTypography>
                )
            )
        },
        {
            accessorKey: 'anggaran',
            header: 'Anggaran',
            size: 20,
            Cell: ({ cell }) => (
                cell.row.original.status === 'komponen' ?
                    (
                        <ArgonTypography
                            // fontWeight={(cell.row.original.status === 'Program' || cell.row.original.status === 'Kegiatan') === 'Program' && 'bold'}
                            variant="inherit"
                            fontSize="small"
                            color={cell.row.original.ket === 'notequal' ? 'error' : 'inherit'}
                        >
                            {
                                parseInt(cell.getValue()) === 0 ? ' ' : parseInt(cell.getValue())?.toLocaleString?.('id-ID', {
                                    style: 'currency',
                                    currency: 'IDR',
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                })
                            }
                        </ArgonTypography>
                    )
                    :
                    ('')
            )
        },
    ];

    return (
        <ArgonBox py={3}>
            <ArgonBox mb={3}>
                <Card>
                    <CardHeader
                        title={
                            <ArgonTypography variant='h6'>Kembali</ArgonTypography>
                        }
                        avatar={
                            <IconButton variant="outlined" onClick={() => navigate(-1)}><ArrowBack /></IconButton>
                        }
                    />
                    <CardContent>
                        <Table aria-label="simple table">
                            <TableBody>
                                <TableRow key={0} >
                                    <TableCell sx={{ fontSize: 'small' }}>Tahun Anggaran</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {data.ta}</TableCell>
                                </TableRow>
                                <TableRow key={1} >
                                    <TableCell sx={{ fontSize: 'small' }}>Perangkat Daerah</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {opd.kd_pd} {opd.nama_pd}</TableCell>
                                </TableRow>
                                <TableRow key={2} >
                                    <TableCell sx={{ fontSize: 'small' }}>Program</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {program.kode} {program.uraian}</TableCell>
                                </TableRow>
                                <TableRow key={3} >
                                    <TableCell sx={{ fontSize: 'small' }}>Kegiatan</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {kegiatan.kode} {kegiatan.uraian}</TableCell>
                                </TableRow>
                                <TableRow key={4} >
                                    <TableCell sx={{ fontSize: 'small' }}>Sub Kegiatan</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {data.kode} {data.uraian}</TableCell>
                                </TableRow>
                                <TableRow key={5} >
                                    <TableCell sx={{ fontSize: 'small' }}>Kinerja</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {data.kinerja}</TableCell>
                                </TableRow>
                                <TableRow key={6} >
                                    <TableCell sx={{ fontSize: 'small' }}>Indikator</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {data.indikator}</TableCell>
                                </TableRow>
                                <TableRow key={7} >
                                    <TableCell sx={{ fontSize: 'small' }}>Satuan</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {data.satuan}</TableCell>
                                </TableRow>
                                <TableRow key={8} >
                                    <TableCell sx={{ fontSize: 'small' }}>Anggaran</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>
                                        : {
                                            data.anggaran?.toLocaleString?.('id-ID', {
                                                style: 'currency',
                                                currency: 'IDR',
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0,
                                            })
                                        }
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </CardContent>
                </Card>
            </ArgonBox>
            <ArgonBox my={3}>
                <Grid container spacing={3} mb={3}>
                    <Grid item xs={12} md={6} lg={6}>
                        <MiniStatisticsCard
                            bgColor='white'
                            title={{
                                text: "Anggaran Sub Kegiatan"
                            }}
                            count={
                                data.anggaran?.toLocaleString?.('id-ID', {
                                    style: 'currency',
                                    currency: 'IDR',
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                })
                            }
                            icon={{ color: "info", component: <AttachMoney /> }}
                        // percentage={{ color: "success", count: "+55%", text: "since yesterday" }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                        <MiniStatisticsCard
                            title={{
                                text: "Total Rincian"
                            }}
                            count={
                                totalRincian?.toLocaleString?.('id-ID', {
                                    style: 'currency',
                                    currency: 'IDR',
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                })
                            }
                            icon={{ color: "error", component: <AttachMoney /> }}
                            percentage={{ color: (totalRincian / data?.anggaran) === 1 ? 'success' : 'error', text: ((totalRincian / data?.anggaran) * 100).toFixed(2) + '%' }}
                        />
                    </Grid>
                </Grid>
            </ArgonBox>
            <ArgonBox mb={1}>
                <Card>
                    <CardContent>
                        <MaterialReactTable
                            columns={columns}
                            data={listRincian}
                            // enableExpanding
                            // enableExpandAll
                            muiTableHeadCellProps={{
                                sx: {
                                    fontSize: '0.875rem !important',
                                    color: 'text.main !important'
                                }
                            }}
                            muiTableFooterCellProps={{
                                sx: {
                                    fontSize: '0.875rem !important',
                                    color: 'text.main !important'
                                }
                            }}
                            muiTopToolbarProps={{
                                sx: { fontSize: '0.875rem' }
                            }}
                            initialState={{
                                expanded: true
                            }}
                            enablePagination={false}
                            enableColumnFilters={false}
                            enableSorting={false}
                            state={{ isLoading: loading }}
                            enableRowActions={false}
                            // positionActionsColumn='first'
                            // displayColumnDefOptions={{
                            //     'mrt-row-actions': {
                            //         header: 'Action', //change header text
                            //         size: 5, //make actions column wider
                            //         alignment: 'left'
                            //     },
                            //     'mrt-row-expand': {
                            //         header: 'Expand', //change header text
                            //         size: 5, //make actions column wider
                            //         alignment: 'left'
                            //     },
                            // }}
                        />
                    </CardContent>
                </Card>
            </ArgonBox>

        </ArgonBox>
    )
}

export default RincianBelanja